<template>
  <aside class="diary" :class="'diary--' + placement">
    <p v-if="placement === 'article'" class="diary__lead">
      <span v-if="keyword">「{{ keyword }}」の夢を、</span>あなたの夢として読み解くなら
    </p>
    <div class="diary__body">
      <img :src="icon" alt="夢占い・夢日記" class="diary__icon" width="72" height="72" loading="lazy">
      <div class="diary__text">
        <p class="diary__name">夢占い・夢日記｜AI夢診断</p>
        <p class="diary__desc">見た夢をそのまま書くと、AIが夢の意味と、吉夢か悪夢かを読み解きます。夢日記として残せるので、くり返し見る夢の変化もわかります。</p>
        <p class="diary__meta">iPhone・iPad向け／無料ではじめられます</p>
      </div>
    </div>
    <a :href="storeUrl" class="diary__button" target="_blank" rel="noopener">App Storeで見る</a>
  </aside>
</template>

<script>
// 夢日記アプリへの入口。計測のため App Store のリンクに ct（場所ごと）を付ける。
export default {
  props: {
    placement: { type: String, default: 'article' },
    keyword: { type: String, default: '' }
  },
  data() {
    return {
      icon: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d6/51/8e/d6518e29-9483-fb2b-be19-c1a77edb9fc0/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/144x144bb.jpg'
    }
  },
  computed: {
    storeUrl() {
      return 'https://apps.apple.com/app/apple-store/id1630615789?pt=118540135&ct=yumemin_' + this.placement + '&mt=8'
    }
  }
}
</script>

<style scoped>
.diary{
  margin: 28px 0 8px 0;
  padding: 16px;
  border-radius: 12px;
  border: solid 1px #27556A;
  background: #F4F8FA;
}
.diary__lead{
  font-weight: bold;
  color: #27556A;
  margin-bottom: 10px;
}
.diary__body{
  display: flex;
  align-items: flex-start;
}
.diary__icon{
  width: 72px;
  height: 72px;
  border-radius: 16px;
  flex-shrink: 0;
  margin-right: 12px;
}
.diary__name{
  font-weight: bold;
  font-size: 1.05em;
}
.diary__desc{
  font-size: .92em;
  line-height: 1.6;
  margin-top: 4px;
}
.diary__meta{
  font-size: .8em;
  color: #5A6B73;
  margin-top: 4px;
}
.diary a.diary__button{
  display: block;
  margin-top: 14px;
  padding: 12px;
  border-radius: 8px;
  background: #27556A;
  color: #fff !important;
  font-weight: bold;
  text-align: center;
}
.diary a.diary__button:hover{
  opacity: .9;
}
.diary--side .diary__desc{
  font-size: .85em;
}
</style>
